import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MD_DIALOG_DATA, MdDialogRef } from '@angular/material';

import { AppMessage } from './../../Common/appMessage';
import { Utility } from './../../Common/Services/utility';
import { AdmManageDomainService } from './adm-manage-domain.service';
import { AppConfig } from './../../Common/appConfiguration';
@Component({
  selector: 'app-adm-manage-domain',
  templateUrl: './adm-manage-domain.component.html',
  styleUrls: ['./adm-manage-domain.component.css'],
  providers: [AdmManageDomainService]
})
export class AdmManageDomainComponent implements OnInit {

  error: string = "";
  form: FormGroup;
  items: any;
  locationId: number;
  expandPanel: number = 0; // expand first div initially
  isSaveDisable: boolean = false;
  itemCount: number = -1;
  //domainExist: boolean = false;
  constructor(
    public dialogRef: MdDialogRef<AdmManageDomainComponent>,
    @Inject(MD_DIALOG_DATA) public data: any,
    public _utility: Utility, private domainService: AdmManageDomainService, private appMessage: AppMessage) {
    this.locationId = Number(this.data);
  }

  ngOnInit() {
    this.getKoala("?locationId=" + this.locationId);
    this.form = new FormGroup({
      whiteList: new FormControl(),
      blackList: new FormControl()
    });

    this.form.valueChanges
      .debounceTime(500)
      .distinctUntilChanged()
      .subscribe(values => {
        this.error = "";

        //let valid = this.validate(values.whiteList.concat(values.blackList).replace(/\n/g, '')); // add all values of blacklist and whitelist in one lines
        //if (valid) {
        this.onValueChanges(values);
        // } else {
        //this.error = 'Allowed chars only (0-9 a-z A-Z . -)';
        //this.isSaveDisable = true;
        // }
      });
  }

  // Check duplicate values
  /**
   * Check duplicate value in Self List()
   * Check duplicate value in cross List (same value can not add in Whitelist and in BlackList both)
   * @param values 
   */
  onValueChanges(values: any) {
    this.isSaveDisable = false;
    this.error = "";
    if (values.blackList || values.whiteList) {
      let blackList = this.cleanArray(values.blackList.split("\n")); // get text area value with in array format
      let whiteList = this.cleanArray(values.whiteList.split("\n"));

      if (this.totalCountValidate(blackList, whiteList)) { // check total count validations first
        if (this.lengthValidate(blackList) && this.lengthValidate(whiteList)) { // check per domain Length validation 
          if (this.checkDuplicate(blackList) || this.checkDuplicate(whiteList) || this.checkDuplicate(blackList.concat(whiteList))) { // Check duplicate domains exists validation
            this.isSaveDisable = true;
            this.error = this.appMessage.getItem["UMsg00086"];
          }
        }
      }

    }
  }

  //'Domain first char can not be "." -- not in use
  checkFirstChar(arr: any): boolean {
    let valid = true;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] && arr[i].indexOf('.') == 0) {
        this.error = this.appMessage.getItem["UMsg00089"];
        this.isSaveDisable = true;
        valid = false;
        break;
      }
    }
    return valid;

  }

  // Check per domain length : it is max 50 chars
  lengthValidate(arr: any): boolean {
    let valid = true;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] && arr[i].length > 50) {
        valid = false;
        this.error = this.appMessage.getItem["UMsg00088"];
        this.isSaveDisable = true;
        break;
      }
    }
    return valid;
  }


  // only 50 domains are allowded. IF length exceeds from 50 values then return false else return true.
  totalCountValidate(blackList: any, whiteList: any): boolean {
    if (blackList.length > 50 || whiteList.length > 50) {
      this.error = this.appMessage.getItem["UMsg00087"];
      this.isSaveDisable = true;
      return false;
    } else {
      return true;
    }
  }

  // Check Value with regex, If regex test passed then return true else return false.
  // validate(value: string): boolean {
  //   let regEx = AppConfig.domainRegEx;
  //   if (!value || regEx.test(value)) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  // get Koalas 
  getKoala(params: string) {
    this._utility.addLoaderCount();
    this.domainService.getKoala(params).subscribe(response => {
      this._utility.onSuccessCallback(response, null, () => {
        this.items = response.response.results;
        this.itemCount = this.items.length;
      });
    }, error => this._utility.onErrorCallback(error));
  }

  // To close the current dialog
  closeDialog() {
    this.dialogRef.close();
  }

  /**
   * When click on save button : Check If no Domains exists for that koala then show error
   *  
   */
  onSaveDomain(koalaId: number) {
    let values = this.form.getRawValue();
    this.error = "";
    let blackList = this.cleanArray(values.blackList.trim().split("\n")); // get text area value with in array format
    let whiteList = this.cleanArray(values.whiteList.trim().split("\n"));
    //if (this.domainExist || (blackList.length > 0 || whiteList.length > 0)) {
    let param = { "koalaId": koalaId, whiteList: whiteList, blackList: blackList };
    this.domainService.postDomain(param).subscribe(res => {
      this._utility.onSuccessCallback(res, this.appMessage.getItem["UMsg00085"]);
      //set new values
      this.form.controls.whiteList.patchValue(whiteList.join('\n'));
      this.form.controls.blackList.patchValue(blackList.join('\n'));
    //  this.domainExist = true;
    }, error => this._utility.onErrorCallback(error));
    //} 
    // else {
    // this.error = "Please add Domains first";
    // }

  }

  /**
   * When panel expanded, hit a request with Koala id and get all domains and set into fields.
   * @param index - row index number
   * @param koalaId  - koala ID
   */
  onOpen(index: number, koalaId: number): void {
    this.error = "";
    this.isSaveDisable = false;
    this.expandPanel = index;
    let whiteListControl = this.form.controls.whiteList;
    let blackListControl = this.form.controls.blackList;

    // reset values
    whiteListControl.patchValue('');
    blackListControl.patchValue('');

    let param = `?koalaId=${koalaId}`;
    this.domainService.getDomain(param).subscribe(res => {
      this._utility.onSuccessCallback(res, null, () => {
        let data = res.response;
        //set new values
        if (data.whiteList.length > 0 || data.blackList.length > 0) {
          //  this.domainExist = true;
          whiteListControl.patchValue(data.whiteList.join('\n'));
          blackListControl.patchValue(data.blackList.join('\n'));
        } else {
          //this.domainExist = false;
        }
      });
    }, error => this._utility.onErrorCallback(error));
  }

  /**
   * when click on Cancel
   */
  onCancel(index: number) {
    this.expandPanel = null;
  }

  /**
   * Example - real array: [1,2,1] --> counts array : ['1': 1, '2': 1] -- >   if (counts[arr[i]] === undefined)  this condition will false for third iteration.
   * @param arr - pass array
   * If duplicate value found return true else return false.
   */
  checkDuplicate(arr: any): boolean {
    let counts = [];
    for (let i = 0; i < arr.length; i++) {
      if (arr[i]) {
        let value = arr[i].trim().toLowerCase();
        if (counts[`${value}`] === undefined) {
          counts[`${value}`] = 1; // push any value "1" to counts temp array on index of origional array value
        } else {
          return true;
        }
      }
    }
    return false;
  }

  // Will remove all falsy values: undefined, null, 0, false, NaN and "" (empty string)
  cleanArray(actual: any) {
    let newArray = new Array();
    for (let i = 0; i < actual.length; i++) {
      if (actual[i]) {
        newArray.push(actual[i]);
      }
    }
    return newArray;
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-domain/adm-manage-domain.component.ts